import React, { useRef, useEffect, useState } from "react";
import { Map, Marker, GoogleApiWrapper, InfoWindow } from "google-maps-react";
import markerIcon from "../../images/markermap.svg";
// import Autocomplete from "react-google-autocomplete";
import Geocode from "react-geocode";

function MapAddress({
  google,
  setMapInfo,
  handelSetAddressList,
  handelSetAddressFormat,
  setNewLatLng,
}) {
  Geocode.setApiKey("AIzaSyCx2x-EzGQOHcYf36Gqtc9g1GP1s5NOfb0");
  Geocode.setLanguage("en");
  Geocode.enableDebug();
  const searchInput = useRef(null);
  let searchBox = null;
  const [location, setLocation] = useState(null);

  useEffect(() => {
    (async () => {
      const { lat, lng } = await getCurrentLocation();
      setLocation({
        lat,
        lng,
      });
    })();
  }, []);

  const getCurrentLocation = () => {
    if (navigator && navigator.geolocation) {
      // eslint-disable-next-line no-undef
      return new Promise((resolve) => {
        navigator.geolocation.getCurrentPosition(
          (pos) => {
            const coords = pos.coords;
            resolve({
              lat: coords.latitude,
              lng: coords.longitude,
            });
          },
          () => {
            fetch("http://ip-api.com/json")
              .then((res) => res.json())
              .then((data) => {
                resolve({
                  lat: data.lat,
                  lng: data.lon,
                });
              })
              .catch(() => {
                resolve({
                  lat: null,
                  lng: null,
                });
              });
          }
        );
      });
    }
    return { lat: 0, lng: 0 };
  };

  useEffect(() => {
    console.log(setNewLatLng, "setNewLatLngsetNewLatLng");
    if (setNewLatLng) {
      setLocation(null);
      setTimeout(() => {
        setLocation(setNewLatLng);
      }, 200);
    }
  }, [setNewLatLng]);

  const onMapClicked = (c, m, e) => {
    // console.log(c)
    // console.log(m)
    let lat = e.latLng.lat();
    let lng = e.latLng.lng();
    console.log("lat,lng: " + lat, lng);

    setLocation({
      lat,
      lng,
    });

    setMapInfo({
      lat,
      lng,
    });
    handelGeocode(lat, lng);
  };

  const handelGeocode = (lat, lng) => {
    Geocode.fromLatLng(lat, lng).then(
      (response) => {
        // console.log(response);
        // console.log(response?.results);
        handelSetAddressList(response?.results);
        const address = response.results[0].formatted_address;
        console.log(address);
        handelSetAddressFormat(address);
      },
      (error) => {
        console.error(error, "errrrrrrrr");
      }
    );
  };

  return (
    <div className="map-holder">
      {/* <input ref={searchInput} onChange={handelChange} className="autocomplete" placeholder={"search..."} type="text" /> */}
      {location && (
        <Map
          streetViewControl={false}
          zoomControl={true}
          mapTypeControl={true}
          fullscreenControl={true}
          initialCenter={{ lat: location?.lat, lng: location?.lng }}
          zoom={18}
          google={google}
          onReady={(map) => {
            // console.log(map, "mapmap")
            handelGeocode(map?.initialCenter?.lat, map?.initialCenter?.lng);
            // let input = document.querySelector('.autocomplete')
            // var searchBox = new window.google.maps.places.SearchBox(input);
            // searchBox.addListener('places_changed', () => {
            // this.handleAutocompelete(searchBox)
            // })
          }}
          onClick={onMapClicked}
          // onDragend={this.centerMoved}
        >
          <Marker
            icon={{
              url: markerIcon,
            }}
            position={{ lat: location?.lat, lng: location?.lng }}
            name={"Current location"}
          />
        </Map>
      )}

      {/* <Autocomplete
  apiKey="AIzaSyCx2x-EzGQOHcYf36Gqtc9g1GP1s5NOfb0"
  onPlaceSelected={(place) => {
    console.log(place);
  }}
/> */}
    </div>
  );
}

export default GoogleApiWrapper({
  apiKey: "AIzaSyCx2x-EzGQOHcYf36Gqtc9g1GP1s5NOfb0",
  // apiKey: "AIzaSyBh6FbV8FeEBGtnwkw1siI4XcpYEM7QyQQ",
  //   apiKey: "AIzaSyD45pqBTY1wlSUJquEtPZraInR2XlRduE8",
  libraries: ["places"],
})(MapAddress);
